// extracted by mini-css-extract-plugin
export default {"table":"NestedCopiesTable_table__NYZn9","row":"NestedCopiesTable_row__Au8Dj"};